import i18n from '../VueI18n'

/**
 *
 * @param {Object} especie Especie que deve ser validada
 * @param {Array<Object>} especies Lista de especies que devem ser usados para validacao
 */
const validarEspecie = (especie, especies) => {
	if (!isUnique(especie, especies)) {
		return {
			isValid: false,
			message: `${i18n.t('aEspecie')} "${especie.espe_ds_nome}" ${i18n.t('jaEstaCadastradaNoSistema')}`,
		}
	}
	return { isValid: true }
}

/**
 * Valida se a espécie possui valores unicos considerando:
 * - espe_ds_nome
 * @param {Object} especie Espécie que deve ser validado
 * @param {Array<Object>} especies Lista de especies que devem ser usados para validacao
 */
function isUnique(especie, especies) {
	return (
		especies.filter((especieDaLista) => especieDaLista.espe_ds_nome === especie.espe_ds_nome)
			.length === 0
	)
}

export default validarEspecie
